module.exports = __webpack_public_path__ + "img/fondo_figma.57112f1a.png";